<template>
  <div class="row sessoesSubaba">
    <div class="col col-md-10 offset-md-1 sessoesSubabaCorpo sessaoUsuarioWidget">
      <header class="sessoesSubabaCabecalho">
        <div>
          <span>Audiência por usuário e evento</span>
          <h2>Sessões detalhadas</h2>
        </div>
        <div class="sessaoUsuarioTotais">
          <span>{{ itens.length }} resultados</span>
          <strong>{{ sessoesTotais }} sessões</strong>
        </div>
      </header>

      <div class="sessoesSubabaFiltros sessaoUsuarioFiltros">
        <Combo
          v-if="
            retornaSite() !== 'Share' &&
            retornaSite() !== 'Stream1x2' &&
            retornaSite() !== '7live'
          "
          class="sessaoUsuarioFiltroSite"
          :itens="$global.sites_filtro_completo()"
          v-model="filtroSite"
        />

        <SearchableCombo
          class="sessaoUsuarioFiltroEvento"
          :itens="itensEventos"
          v-model="filtroEvento"
          placeholder="Todos os eventos"
          @change="eventoSelecionado"
        />

        <label class="sessaoUsuarioCampo">
          <i class="fa fa-user" aria-hidden="true"></i>
          <input
            v-model.trim="filtroUsuario"
            type="search"
            placeholder="Email do usuário"
            aria-label="Filtrar sessões por email"
            @keyup="keyupFiltroUsuario"
          />
        </label>

        <label class="sessaoUsuarioCampo sessaoUsuarioCampoIp">
          <i class="fa fa-globe" aria-hidden="true"></i>
          <input
            v-model.trim="filtroIp"
            type="search"
            placeholder="Endereço IP"
            aria-label="Filtrar sessões por IP"
            @keyup="keyupFiltroIp"
          />
        </label>

        <button
          type="button"
          class="sessaoUsuarioFiltrar"
          :disabled="carregando"
          @click="carregarItens"
        >
          <i
            class="fa"
            :class="carregando ? 'fa-refresh fa-spin' : 'fa-search'"
            aria-hidden="true"
          ></i>
          Filtrar
        </button>
      </div>

      <div v-if="erro" class="sessaoUsuarioEstado sessaoUsuarioErro">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span>{{ erro }}</span>
        <button type="button" @click="carregarItens">Tentar novamente</button>
      </div>

      <div v-else class="sessaoUsuarioTabela">
        <div class="sessaoUsuarioTabelaCabecalho sessaoUsuarioGrade">
          <span>Usuário</span>
          <span>Evento</span>
          <span>IP</span>
          <span>Sessões</span>
        </div>

        <div v-if="carregando && !itens.length" class="sessaoUsuarioEstado">
          <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
          <span>Consultando sessões</span>
        </div>

        <div v-else-if="!itens.length" class="sessaoUsuarioEstado">
          <i class="fa fa-users" aria-hidden="true"></i>
          <span>{{ mensagemVazia }}</span>
        </div>

        <div v-else class="sessaoUsuarioLista">
          <article
            v-for="item in itens"
            :key="item._id.site + '-' + item._id.email + '-' + item._id.evento"
            class="sessaoUsuarioLinha sessaoUsuarioGrade"
          >
            <div class="sessaoUsuarioIdentidade">
              <span class="sessaoUsuarioAvatar">
                <i class="fa fa-user" aria-hidden="true"></i>
              </span>
              <span>
                <strong>{{ item.usuario.email }}</strong>
                <small>{{ item.usuario.site || "Sem site" }}</small>
              </span>
            </div>

            <div class="sessaoUsuarioEvento">
              <span>
                <strong>{{ item.evento.nome }}</strong>
                <small>{{ item.evento.competicao || "Sem competição" }}</small>
              </span>
              <small
                class="sessaoUsuarioSituacao"
                :class="'sessaoUsuarioSituacao' + item.evento.situacao"
              >
                {{ nomeSituacao(item.evento.situacao) }}
              </small>
            </div>

            <div class="sessaoUsuarioIps" :title="item.ips.join(', ')">
              <i class="fa fa-globe" aria-hidden="true"></i>
              <span>
                <strong>{{ item.ips[0] || "Não identificado" }}</strong>
                <small v-if="item.ips.length > 1">
                  +{{ item.ips.length - 1 }} outro
                </small>
                <small v-else>{{ resumoCanais(item.canais) }}</small>
              </span>
            </div>

            <button
              type="button"
              class="sessaoUsuarioAcessos"
              data-target="#dialogAcessos"
              data-toggle="modal"
              title="Visualizar sessões"
              @click="abrirAcessos(item)"
            >
              <i class="fa fa-list-ul" aria-hidden="true"></i>
              <strong>{{ item.total }}</strong>
            </button>
          </article>
        </div>
      </div>

      <ListSessaoViewDetalhes ref="listSessaoViewDetalhes" />
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";
import SearchableCombo from "../components/SearchableCombo.vue";
import ListSessaoViewDetalhes from "./ListSessaoViewDetalhes.vue";

export default {
  name: "ListSessaoView",
  components: { Combo, ListSessaoViewDetalhes, SearchableCombo },
  props: { itensLimit: { type: Number, default: 10000 } },
  computed: {
    mensagemVazia() {
      if (!this.consultaExecutada) {
        return "Selecione um evento ou informe um email ou IP para consultar.";
      }

      return "Nenhuma sessão ativa encontrada para os filtros informados.";
    },
    sessoesTotais() {
      return this.itens.reduce(function (total, item) {
        return total + item.total;
      }, 0);
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    abrirAcessos(item) {
      this.$refs.listSessaoViewDetalhes.carregarItens(
        item.evento._id,
        item.usuario.email,
        this.filtroIp
      );
    },
    async selecionarEvento(id) {
      if (!this.itensEventos.length) {
        await this.carregarItensEventos();
      }

      this.filtroEvento = id;
      await this.$nextTick();
      await this.carregarItens();
    },
    async carregarItens() {
      var possuiFiltro =
        this.filtroEvento !== "" ||
        this.filtroUsuario !== "" ||
        this.filtroIp !== "";

      if (!possuiFiltro) {
        this.itens = [];
        this.erro = "";
        this.consultaExecutada = false;
        return;
      }

      var requisicao = ++this.requisicaoAtual;
      var filtros = [];

      if (this.filtroEvento !== "") {
        filtros.push("evento=" + encodeURIComponent(this.filtroEvento));
      }

      if (this.filtroUsuario !== "") {
        filtros.push("usuario=" + encodeURIComponent(this.filtroUsuario));
      }

      if (this.filtroIp !== "") {
        filtros.push("ip=" + encodeURIComponent(this.filtroIp));
      }

      if (this.filtroSite !== "Todos") {
        filtros.push("site=" + encodeURIComponent(this.filtroSite));
      }

      filtros.push("_limit=" + this.itensLimit);
      this.carregando = true;
      this.erro = "";

      try {
        var response = await api.get("/sessaoView?" + filtros.join("&"));
        api.valid(response.data, this.$router);

        if (response.data.erro) {
          throw new Error(
            response.data.mensagem || "Não foi possível consultar as sessões."
          );
        }

        if (requisicao !== this.requisicaoAtual) {
          return;
        }

        this.itens = response.data.itens || [];
        this.consultaExecutada = true;
      } catch (erro) {
        if (requisicao !== this.requisicaoAtual) {
          return;
        }

        this.itens = [];
        this.erro =
          erro && erro.message
            ? erro.message
            : "Não foi possível consultar as sessões.";
      } finally {
        if (requisicao === this.requisicaoAtual) {
          this.carregando = false;
        }
      }
    },
    async carregarItensEventos() {
      if (this.carregamentoEventos) {
        return this.carregamentoEventos;
      }

      var obj = this;

      this.carregamentoEventos = (async function () {
        var response = await api.get("/evento?_limit=10000");
        api.valid(response.data, obj.$router);
        obj.itensEventos = [];

        (response.data.itens || []).forEach(function (evento) {
          obj.itensEventos.push({
            id: evento._id,
            nome: evento.site + " / " + evento.nome,
          });
        });
      })();

      try {
        await this.carregamentoEventos;
      } finally {
        this.carregamentoEventos = null;
      }
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);
      this.timerFiltroUsuario = setTimeout(this.carregarItens, 700);
    },
    keyupFiltroIp() {
      clearTimeout(this.timerFiltroIp);
      this.timerFiltroIp = setTimeout(this.carregarItens, 600);
    },
    eventoSelecionado() {
      this.$nextTick(this.carregarItens);
    },
    nomeSituacao(situacao) {
      var situacoes = {
        1: "Previsto",
        2: "Invisível",
        3: "Ao vivo",
      };

      return situacoes[situacao] || "Ativo";
    },
    resumoCanais(canais) {
      if (!canais || !canais.length) {
        return "Canal não identificado";
      }

      return canais.length === 1
        ? "Canal " + canais[0]
        : canais.length + " canais";
    },
  },
  mounted() {
    this.carregarItensEventos();
  },
  beforeDestroy() {
    clearTimeout(this.timerFiltroUsuario);
    clearTimeout(this.timerFiltroIp);
  },
  data() {
    return {
      carregamentoEventos: null,
      carregando: false,
      consultaExecutada: false,
      erro: "",
      filtroEvento: "",
      filtroIp: "",
      filtroSite: "Todos",
      filtroUsuario: "",
      itens: [],
      itensEventos: [],
      requisicaoAtual: 0,
      timerFiltroIp: null,
      timerFiltroUsuario: null,
    };
  },
};
</script>

<style>
.sessaoUsuarioWidget {
  text-align: left;
}

.sessaoUsuarioTotais {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.sessaoUsuarioTotais span {
  color: #778189;
  font-size: 9px;
}

.sessaoUsuarioTotais strong {
  color: #344149;
  font-size: 11px;
}

.sessaoUsuarioFiltros {
  display: grid !important;
  gap: 8px !important;
  grid-template-columns: 150px minmax(220px, 1fr) minmax(170px, 220px) 180px auto;
}

.sessaoUsuarioFiltroEvento,
.sessaoUsuarioFiltroSite {
  margin: 0 !important;
  max-width: none !important;
  min-width: 0;
}

.sessaoUsuarioCampo {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd5d9;
  display: flex;
  height: 34px;
  margin: 0;
  min-width: 0;
}

.sessaoUsuarioCampo i {
  color: #78838b;
  margin: 0 9px;
}

.sessaoUsuarioCampo input {
  background: transparent;
  border: 0;
  color: #31383d;
  font-size: 11px;
  height: 100%;
  min-width: 0;
  outline: 0;
  padding: 0 8px 0 0;
  width: 100%;
}

.sessaoUsuarioFiltrar {
  align-items: center;
  background: #ffffff;
  border: 1px solid #4e806a;
  color: #2e6f53;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  gap: 6px;
  height: 34px;
  justify-content: center;
  padding: 0 12px;
}

.sessaoUsuarioFiltrar:hover {
  background: #edf6f1;
}

.sessaoUsuarioFiltrar:disabled {
  cursor: wait;
  opacity: 0.65;
}

.sessaoUsuarioTabela {
  background: #ffffff;
}

.sessaoUsuarioGrade {
  align-items: center;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(190px, 1fr) minmax(250px, 1.35fr) minmax(150px, 0.75fr) 72px;
  padding-left: 15px;
  padding-right: 15px;
}

.sessaoUsuarioTabelaCabecalho {
  background: #f1f3f5;
  border-bottom: 1px solid #dce1e4;
  color: #69737b;
  font-size: 8px;
  font-weight: 700;
  min-height: 31px;
  text-transform: uppercase;
}

.sessaoUsuarioTabelaCabecalho span:last-child {
  text-align: center;
}

.sessaoUsuarioLista {
  max-height: 650px;
  overflow-y: auto;
}

.sessaoUsuarioLinha {
  border-bottom: 1px solid #e7eaed;
  min-height: 62px;
  transition: background 0.15s ease;
}

.sessaoUsuarioLinha:hover {
  background: #f7f9f8;
}

.sessaoUsuarioIdentidade,
.sessaoUsuarioEvento,
.sessaoUsuarioIps {
  align-items: center;
  display: flex;
  gap: 9px;
  min-width: 0;
}

.sessaoUsuarioIdentidade > span:last-child,
.sessaoUsuarioEvento > span,
.sessaoUsuarioIps > span {
  min-width: 0;
}

.sessaoUsuarioIdentidade strong,
.sessaoUsuarioIdentidade small,
.sessaoUsuarioEvento strong,
.sessaoUsuarioEvento small,
.sessaoUsuarioIps strong,
.sessaoUsuarioIps small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sessaoUsuarioIdentidade strong,
.sessaoUsuarioEvento strong,
.sessaoUsuarioIps strong {
  color: #30383e;
  font-size: 11px;
}

.sessaoUsuarioIdentidade small,
.sessaoUsuarioEvento small,
.sessaoUsuarioIps small {
  color: #78828a;
  font-size: 8px;
  margin-top: 2px;
}

.sessaoUsuarioAvatar {
  align-items: center;
  background: #e7f0ec;
  color: #34765a;
  display: inline-flex;
  flex: 0 0 28px;
  height: 28px;
  justify-content: center;
}

.sessaoUsuarioEvento {
  justify-content: space-between;
}

.sessaoUsuarioSituacao {
  background: #edf0f2;
  color: #5d6870 !important;
  flex: 0 0 auto;
  font-size: 7px !important;
  font-weight: 700;
  margin: 0 !important;
  padding: 4px 6px;
  text-transform: uppercase;
}

.sessaoUsuarioSituacao3 {
  background: #e1f3e9;
  color: #26734f !important;
}

.sessaoUsuarioSituacao1 {
  background: #e7f0f7;
  color: #386f97 !important;
}

.sessaoUsuarioSituacao2 {
  background: #f0edf3;
  color: #70568f !important;
}

.sessaoUsuarioIps > i {
  color: #71808a;
}

.sessaoUsuarioAcessos {
  align-items: center;
  background: #ffffff;
  border: 1px solid #9eabb3;
  color: #354149;
  display: inline-flex;
  font-size: 10px;
  gap: 7px;
  height: 30px;
  justify-content: center;
  justify-self: center;
  min-width: 54px;
}

.sessaoUsuarioAcessos:hover {
  background: #edf4f1;
  border-color: #4b8068;
  color: #286447;
}

.sessaoUsuarioEstado {
  align-items: center;
  color: #7e888f;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  gap: 8px;
  justify-content: center;
  min-height: 180px;
  padding: 20px;
  text-align: center;
}

.sessaoUsuarioEstado > i {
  font-size: 20px;
}

.sessaoUsuarioErro {
  color: #a14545;
}

.sessaoUsuarioErro button {
  background: transparent;
  border: 1px solid #bc7777;
  color: inherit;
  font-size: 9px;
  padding: 5px 9px;
}

.body-dark .sessaoUsuarioTotais strong,
.body-dark .sessaoUsuarioCampo input,
.body-dark .sessaoUsuarioIdentidade strong,
.body-dark .sessaoUsuarioEvento strong,
.body-dark .sessaoUsuarioIps strong {
  color: var(--dark-text-soft) !important;
}

.body-dark .sessaoUsuarioTabela,
.body-dark .sessaoUsuarioCampo,
.body-dark .sessaoUsuarioAcessos,
.body-dark .sessaoUsuarioFiltrar {
  background: var(--dark-surface) !important;
  border-color: var(--dark-border) !important;
}

.body-dark .sessaoUsuarioTabelaCabecalho,
.body-dark .sessaoUsuarioSituacao,
.body-dark .sessaoUsuarioAvatar {
  background: var(--dark-surface-alt) !important;
  color: var(--dark-text-soft) !important;
}

.body-dark .sessaoUsuarioLinha {
  border-color: var(--dark-border-soft) !important;
}

.body-dark .sessaoUsuarioLinha:hover {
  background: var(--dark-surface-raised) !important;
}

.body-dark .sessaoUsuarioIdentidade small,
.body-dark .sessaoUsuarioEvento small,
.body-dark .sessaoUsuarioIps small,
.body-dark .sessaoUsuarioTotais span,
.body-dark .sessaoUsuarioEstado {
  color: var(--dark-muted) !important;
}

@media (max-width: 1100px) {
  .sessaoUsuarioFiltros {
    grid-template-columns: 150px minmax(220px, 1fr) minmax(170px, 1fr);
  }

  .sessaoUsuarioCampoIp {
    grid-column: 1 / 2;
  }

  .sessaoUsuarioFiltrar {
    justify-self: start;
  }
}

@media (max-width: 767px) {
  .sessaoUsuarioFiltros {
    grid-template-columns: 1fr;
  }

  .sessaoUsuarioCampoIp {
    grid-column: auto;
  }

  .sessaoUsuarioFiltrar {
    width: 100%;
  }

  .sessaoUsuarioTabelaCabecalho {
    display: none;
  }

  .sessaoUsuarioGrade {
    gap: 10px;
    grid-template-columns: minmax(0, 1fr) 58px;
    padding: 11px 12px;
  }

  .sessaoUsuarioLinha {
    align-items: start;
  }

  .sessaoUsuarioEvento,
  .sessaoUsuarioIps {
    grid-column: 1 / 2;
    padding-left: 37px;
  }

  .sessaoUsuarioAcessos {
    grid-column: 2;
    grid-row: 1 / 4;
    height: 34px;
  }
}
</style>
